import type { ReactNode } from 'react';

import { Cell } from '../components/index.ts';
import type { DndColumn } from './types.ts';

export function renderDndColumns(columns: DndColumn[], cellProps: Record<string, unknown>): ReactNode {
  return columns.map(({ component: Component, name, contentType, title }) => (
    <Cell {...(contentType ? { contentType } : { title: title ?? name })} key={name}>
      {Component && <Component column={{ name, contentType, title }} {...cellProps} />}
    </Cell>
  ));
}
